module.exports = "<section id=\"start\" *ngIf=\"stateIsStart\">\n    <fllt-landing (start)=\"startTest()\"></fllt-landing>\n</section>\n\n<section id=\"question\" *ngIf=\"stateIsQuestion\">\n    <fllt-question [quiz]=\"quiz\" (ended)=\"getResult()\"></fllt-question>\n</section>\n\n<section id=\"result\" *ngIf=\"stateIsResult\">\n    <fllt-result [quiz]=\"quiz\" (restart)=\"startTest()\"></fllt-result>\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 145
// module chunks = 1